import React from 'react';
import {useDispatch} from 'react-redux';

import useTypedSelector from 'web-app/react/hooks/use-typed-selector';

import * as Actions from './actions';
import * as Selectors from './selectors';
import Dialog from './dialog';

export default () => {
    const dialogIDs = useTypedSelector(state => Selectors.dialogIDs(state));

    const dispatch = useDispatch();

    const handleClose = React.useCallback(
        (id: string) => {
            dispatch(Actions.hide.action(id));
        },
        [dispatch],
    );

    return (
        <>
            {dialogIDs.map(id => (
                <Dialog id={id} key={id} handleClose={handleClose} />
            ))}
        </>
    );
};
